/* eslint-disable complexity */
/* eslint-disable react/no-deprecated */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';
import styles from './index.css';
import { hocToolbarItem } from './toolbar-item-hoc';
import { ActionType } from '../../../editor/src/js/constants/common-action-type';
import { autorun } from 'mobx';
import {
    NO_COLOR,
    RECENT_COLOR_KEY,
} from '@src/slide/infrastructure/module/independent/color/constant';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import {
    TDWModuleType,
    TDWOperationType,
    TDWActionType, TDWVer6Type,
} from '../../../../slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { StyleMode } from '../../../editor/src/js/constants/float-toobbar-data';
import classNames from 'classnames';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { IReactionDisposer } from 'mobx/lib/internal';
import { InjectorService } from '@tencent/workbench';
import { BorderColorFeature } from '@framework/workbench/ui/border-color/border-color-feature';
import { FillColorFeature } from '@framework/workbench/ui/fill-color/fill-color-feature';
import { ForeColorFeature } from '@framework/workbench/ui/fore-color/fore-color-feature';
import userLocalStorage, { LocalStorageKeys } from '@src/slide/infrastructure/module/independent/local-storage';

interface IToolbarItemColorState {
    selected: boolean;
    selectedIndex: number;
    color: string;
}

const Content = (item) => {
    let style;
    if (item.color === NO_COLOR) {
        style = { backgroundColor: 'transparent' };
    } else {
        style = { backgroundColor: item.color };
    }
    return <div onClick={item.onContentClick}
        className={classNames({
            [styles.quickSettingItemContainer]: item.isQuickModel,
        })}>

        <img className={classNames({
            [styles.icon]: true,
            [styles.hover]: true,
        })}
        src={item.icon} />
        <div className={classNames({
            [styles.colorContainer]: true,
            [styles.quickSettingColorContainer]: true,
        })} style={style}></div>
    </div >;
};

const ItemComponent = hocToolbarItem(Content);

// id->key的映射
const idColorKeys = {
    [ActionType.FORECOLOR]: LocalStorageKeys.FORECOLOR as LocalStorageKeys.FORECOLOR,
    [ActionType.BACKCOLOR]: LocalStorageKeys.BACKCOLOR as LocalStorageKeys.BACKCOLOR,
    [ActionType.FILLCOLOR]: LocalStorageKeys.FILLCOLOR as LocalStorageKeys.FILLCOLOR,
    [ActionType.BORDERCOLOR]:
    LocalStorageKeys.BORDER_COLOR_RECENT_COLOR as LocalStorageKeys.BORDER_COLOR_RECENT_COLOR,
};

export default class ToolbarItemColor extends Component<any, IToolbarItemColorState> {
    private willUnmount: boolean;
    private autorun?: IReactionDisposer;
    private num: number;

    public constructor(p) {
        super(p);

        this.state = {
            selected: false,
            selectedIndex: 0,
            color: this.getDefaultColor(p.id),
        };
    }

    public componentDidMount() {
        this.setState({ color: this.getRecentColorWithId(this.props.id) });
        this.autorun = autorun(() => {
            if (this.willUnmount) return;
            const num = this.getMenuManager()?.hideAllMenuNum;
            const isOtherMenuShown = this.getMenuManager()?.isMenuShown || this.num !== num;
            this.num = Number(num);
            if (this.state.selected && isOtherMenuShown) {
                this.setState({ selected: false });
            }
        });
    }

    public componentWillReceiveProps() {
        const color = this.getRecentColorWithId(this.props.id);
        this.setState({ color });
    }

    public componentWillUnmount() {
        this.willUnmount = true;
        this.autorun?.();
    }

    public render() {
        const isQuickModel = this.props.model === StyleMode.QUICK_SETTING;
        const idPreFix = isQuickModel ? (`${StyleMode.QUICK_SETTING + (this.props.keyIndex || 0)}-`) : '';
        const dropdownContent = this.getColorPanelService(this.props.id).
            getColorDropDownContent(TDWVer6Type.COLOR_PICKER_FLOAT);
        const dropdownHeight = this.getColorPanelHeight(this.props.id);

        return (
            <ItemComponent
                {...this.props as any}
                selected={this.state.selected}
                color={this.state.color}
                dropdownHover={true}
                idPreFix={idPreFix}
                isQuickModel={isQuickModel}
                isColorPanel={true}
                dropdownContent={dropdownContent}
                dropdownHeight={dropdownHeight}
                onContentClick={this.handleContentClick}/>
        );
    }


    // 默认色值，设计新给
    private getDefaultColor = (id) => {
        switch (id) {
            case ActionType.FORECOLOR:
                return '#ff0200';
            case ActionType.BACKCOLOR:
                return '#ffff00';
            case ActionType.FILLCOLOR:
                return '#0188fb';
            case ActionType.BORDERCOLOR:
                return '#5c5c5c';
        }
        return '#ffff00';
    };

    private getRecentColorWithId = (id: string) => {
        if (idColorKeys[id]) {
            return userLocalStorage.getItem(idColorKeys[id], this.getDefaultColor(id));
        }
        // 没有此枚举
        // eslint-disable-next-line @tencent/i18next/no-literal-string
        console.error('该id不在idColorKeys的枚举中');
        return localStorage.getItem(`${id}_recent_color`) || this.getDefaultColor(id);
    };

    private handleContentClick = (e) => {
        if (this.props.disabled) {
            return;
        }
        e.stopPropagation();
        this.getColorPanelService(this.props.id).onClick({
            defaultColor: this.getDefaultColor(this.props.id),
        });
        this.reportContentClick();
    };

    // reportContentClick的辅助功能函数
    // 当 props.id = ActionType.FILLCOLOR 时调用，依据不同的类型返回不同的TDWActionType状态
    private judgeTypeFromFillColor(model) {
        let action;
        switch (model.type) {
            case UIModelType.SHAPE: // 文本或形状
                if (model.props.subType === 1) {  // 文本框
                    action = TDWActionType.FAST_STUFF_TEXT;
                } else {  // 形状
                    action = TDWActionType.FAST_STUFF_SHAPE;
                }
                break;
            case UIModelType.IMAGE:
                action = TDWActionType.FAST_STUFF_IMG;
                break;
            case UIModelType.TABLE:
                action = TDWActionType.FAST_STUFF_FORM;
                break;
        }
        return action;
    }

    // reportContentClick的辅助功能函数
    // 当 props.id = ActionType.BORDERCOLOR 时调用，依据不同的类型返回不同的TDWActionType状态
    private judgeTypeFromBorderColor(model) {
        let action;
        switch (model.type) {
            case UIModelType.SHAPE: // 文本或形状
                if (model.props.subType === 1) {  // 文本框
                    action = TDWActionType.FAST_FRAME_TEXT;
                } else {  // 形状
                    action = TDWActionType.FAST_FRAME_SHAPE;
                }
                break;
            case UIModelType.IMAGE:
                action = TDWActionType.FAST_FRAME_IMG;
                break;
            case UIModelType.TABLE:
                action = TDWActionType.FAST_FRAME_FROM;
                break;
        }
        return action;
    }
    private reportContentClick() {
        // 上报
        let action;
        const model = this.getAppService().viewableServiceLayer.selectionService.getSelectedModel();
        switch (this.props.id) {
            case ActionType.FILLCOLOR:
                action = this.judgeTypeFromFillColor(model);
                break;
            case ActionType.BORDERCOLOR:
                action = this.judgeTypeFromBorderColor(model);
                break;
        }
        if (action) {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_EDIT_FORMAT,
                action,
            });
        }
    }
    private getMenuManager() {
        return this.getAppService().editableServiceLayer?.menuManager;
    }

    private getAppService(): IPcEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }

    private getColorPanelHeight(mode) {
        switch (mode) {
            case ActionType.BORDERCOLOR:
                return 455;
            case ActionType.FILLCOLOR:
                return 455;
            default:
                return 325;
        }
    }

    private getColorPanelService(mode) {
        switch (mode) {
            case ActionType.BORDERCOLOR:
                return InjectorService.get(BorderColorFeature);
            case ActionType.FILLCOLOR:
                return InjectorService.get(FillColorFeature);
            default:
                return InjectorService.get(ForeColorFeature);
        }
    }
}
